/**
 * Tiny CSV exporter — Excel-friendly UTF-8 with BOM so Hebrew renders
 * correctly when the file is double-clicked from Finder/Explorer.
 *
 *   exportRowsToCSV({
 *     filename: "users.csv",
 *     columns: [
 *       { key: "email", label: "Email" },
 *       { key: "name",  label: "שם" },
 *       // optional: { key, label, fmt: (row) => "..." }
 *     ],
 *     rows: [{...}, {...}],
 *   })
 *
 * No external dependency — RFC 4180 quoting handled inline.
 */
function escapeCsv(value) {
  if (value === null || value === undefined) return "";
  const s = String(value);
  // Quote when the cell contains a quote, comma, newline, or starts/ends with whitespace.
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function exportRowsToCSV({ filename, columns, rows }) {
  const header = columns.map((c) => escapeCsv(c.label)).join(",");
  const body = rows
    .map((row) =>
      columns
        .map((c) => {
          const raw = c.fmt ? c.fmt(row) : row[c.key];
          return escapeCsv(raw);
        })
        .join(",")
    )
    .join("\n");
  // BOM (U+FEFF) — Excel won't auto-detect UTF-8 without it on Windows.
  const csv = "\uFEFF" + header + "\n" + body + "\n";
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
